export const orderTabs = {
  All: 0,
  Pending: 1,
  Accepted: 2,
  ReadyToPickUp: 3,
  AssignedToTeam: 4,
  AssignedToDriver: 5,
  OrderAcceptedByDriver: 6,
  ReachedPickupLocation: 7,
  OrderPickedUp: 8,
  OnTheWay: 9,
  Delivered: 10,
  CancelledByUser: 11,
  CancelledByAdmin: 12,
  REQUEST_RETURN: 13,
  RETURN_ACCEPTED: 14,
  RETURN_REJECTED: 15,
  ALL: 50,
  OrderNotAccepted: 28,
  SubstituteProductRequested: 29
};
